import { render } from "./page_5.vue?vue&type=template&id=755573a6&scoped=true"
import script from "./page_5.vue?vue&type=script&lang=js"
export * from "./page_5.vue?vue&type=script&lang=js"

import "./page_5.vue?vue&type=style&index=0&id=755573a6&scoped=true&lang=css"

import exportComponent from "/Users/felipewalflan/Documents/Gitlab gen-t/_front/base-questionnaire/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-755573a6"]])

export default __exports__